// Wait for DOM
document.addEventListener('DOMContentLoaded', () => {
  initWishlistIcons();
  
  // If we are on the wishlist page, load the grids
  if (document.querySelector('.wishlist-page')) {
    renderWishlistPage();
  }
});

// Helper to get array from localStorage
function getStorageArray(key) {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
}

// Helper to set array to localStorage
function setStorageArray(key, arr) {
  localStorage.setItem(key, JSON.stringify(arr));
}

// Format money (basic fallback, typically Shopify has a global formatter but we'll do simple INR)
function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

// ====== GLOBAL WISHLIST LOGIC ======

function toggleWishlist(handle, btnElement) {
  let wishlist = getStorageArray('wishlist');
  const index = wishlist.indexOf(handle);
  
  if (index > -1) {
    // Remove
    wishlist.splice(index, 1);
  } else {
    // Add if not already present to prevent duplicates
    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
    }
  }
  
  setStorageArray('wishlist', wishlist);
  
  // Sync all buttons on the page that toggle wishlist for this product
  syncWishlistButtonsForHandle(handle);
  
  // If on wishlist page and removed, re-render
  if (document.querySelector('.wishlist-page') && index > -1) {
    renderWishlistPage();
  }
}

function syncWishlistButtonsForHandle(handle) {
  const wishlist = getStorageArray('wishlist');
  const buttons = document.querySelectorAll(`.wishlist-toggle-btn[data-handle="${handle}"]`);
  
  buttons.forEach(btn => {
    const textSpan = btn.querySelector('span');
    const hasWishlist = wishlist.includes(handle);
    
    if (hasWishlist) {
      btn.classList.add('active');
      if (textSpan) {
        textSpan.textContent = 'Remove from Wishlist';
        const svg = btn.querySelector('svg');
        if (svg) svg.outerHTML = getHeartFilledSVG();
      } else {
        btn.innerHTML = getHeartFilledSVG();
      }
    } else {
      btn.classList.remove('active');
      if (textSpan) {
        textSpan.textContent = 'Add to Wishlist';
        const svg = btn.querySelector('svg');
        if (svg) svg.outerHTML = getHeartOutlineSVG();
      } else {
        btn.innerHTML = getHeartOutlineSVG();
      }
    }
  });
}

function initWishlistIcons() {
  const wishlist = getStorageArray('wishlist');
  const buttons = document.querySelectorAll('.wishlist-toggle-btn');
  
  buttons.forEach(btn => {
    const handle = btn.getAttribute('data-handle');
    const textSpan = btn.querySelector('span');
    
    if (wishlist.includes(handle)) {
      btn.classList.add('active');
      if (textSpan) {
        textSpan.textContent = 'Remove from Wishlist';
        const svg = btn.querySelector('svg');
        if (svg) svg.outerHTML = getHeartFilledSVG();
      } else {
        btn.innerHTML = getHeartFilledSVG();
      }
    } else {
      btn.classList.remove('active');
      if (textSpan) {
        textSpan.textContent = 'Add to Wishlist';
        const svg = btn.querySelector('svg');
        if (svg) svg.outerHTML = getHeartOutlineSVG();
      } else {
        btn.innerHTML = getHeartOutlineSVG();
      }
    }
    
    // Attach click if not already attached
    if (!btn.hasAttribute('data-initialized')) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(handle, btn);
      });
      btn.setAttribute('data-initialized', 'true');
    }
  });
}

function getHeartOutlineSVG() {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
}

function getHeartFilledSVG() {
  return `<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
}

// ====== RECENTLY VIEWED LOGIC ======

function trackRecentlyViewed(handle) {
  if (!handle) return;
  let viewed = getStorageArray('recently_viewed');
  
  // Remove if exists to push to front
  const index = viewed.indexOf(handle);
  if (index > -1) {
    viewed.splice(index, 1);
  }
  
  viewed.unshift(handle);
  
  // Keep only last 10
  if (viewed.length > 10) {
    viewed = viewed.slice(0, 10);
  }
  
  setStorageArray('recently_viewed', viewed);
}

// ====== WISHLIST PAGE RENDERING ======

async function fetchProductData(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    console.error('Error fetching product:', handle, error);
    return null;
  }
}

async function renderWishlistPage() {
  const wishlist = getStorageArray('wishlist');
  const recentlyViewed = getStorageArray('recently_viewed');
  
  const wishlistGrid = document.getElementById('wishlist-grid');
  const controls = document.getElementById('wishlist-controls');
  const recentlyViewedGrid = document.getElementById('recently-viewed-grid');
  const recentlyViewedSection = document.getElementById('recently-viewed-section');

  // Render Wishlist
  if (wishlist.length === 0) {
    wishlistGrid.innerHTML = '<div class="wishlist-empty">Your wishlist is currently empty.</div>';
    if(controls) controls.style.display = 'none';
  } else {
    wishlistGrid.innerHTML = '';
    
    let validProductsCount = 0;
    let newWishlist = [];
    let processedHandles = new Set();
    
    for (const handle of wishlist) {
      if (processedHandles.has(handle)) continue;
      processedHandles.add(handle);
      
      const product = await fetchProductData(handle);
      if (product) {
        wishlistGrid.innerHTML += buildWishlistCard(product, true);
        validProductsCount++;
        newWishlist.push(handle);
      }
    }
    
    // Clean up dead handles from localStorage
    if (newWishlist.length !== wishlist.length) {
      setStorageArray('wishlist', newWishlist);
    }
    
    if (validProductsCount > 0) {
      if(controls) controls.style.display = 'flex';
    } else {
      wishlistGrid.innerHTML = '<div class="wishlist-empty">Your wishlist is currently empty.</div>';
      if(controls) controls.style.display = 'none';
    }
  }

  // Render Recently Viewed
  if (recentlyViewed.length === 0) {
    recentlyViewedSection.style.display = 'none';
  } else {
    // Filter out items already in wishlist to avoid duplicates in the UI
    const filteredViewed = recentlyViewed.filter(h => !wishlist.includes(h));
    
    if (filteredViewed.length > 0) {
      recentlyViewedSection.style.display = 'block';
      recentlyViewedGrid.innerHTML = '';
      
      for (const handle of filteredViewed.slice(0,4)) { // Show max 4
        const product = await fetchProductData(handle);
        if (product) {
          recentlyViewedGrid.innerHTML += buildWishlistCard(product, false);
        }
      }
    } else {
      recentlyViewedSection.style.display = 'none';
    }
  }
  
  attachWishlistPageEvents();
}

function buildWishlistCard(product, isWishlistItem) {
  // Extract a subtitle from description if possible
  let subtitle = product.type || '';
  
  const image = product.featured_image || '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
  const secondaryImage = (product.images && product.images.length > 1) ? product.images[1] : null;
  
  let headerHtml = '';
  if (isWishlistItem) {
    headerHtml = `
      <div class="wl-card-overlay-actions">
        <label class="custom-checkbox-wrapper">
          <input type="checkbox" class="wl-card-checkbox" value="${product.variants[0].id}">
          <span class="checkmark"></span>
        </label>
        <button class="wl-card-remove wishlist-toggle-btn active" data-handle="${product.handle}">
          ${getHeartFilledSVG()}
        </button>
      </div>
    `;
  }

  let imagesHtml = `<img src="${image}" alt="${product.title}" class="wl-card-img product-card-img primary">`;
  if (secondaryImage) {
    imagesHtml += `<img src="${secondaryImage}" alt="${product.title}" class="wl-card-img product-card-img secondary">`;
  }

  return `
    <div class="wl-card product-card" data-handle="${product.handle}">
      ${headerHtml}
      <a href="${product.url}" class="wl-card-img-wrap product-card-img-wrap">
        ${imagesHtml}
      </a>
      <div class="wl-card-info">
        <p class="wl-card-vendor">${product.vendor}</p>
        <a href="${product.url}" class="wl-card-title">${product.title}</a>
        <p class="wl-card-desc">${subtitle}</p>
        <div class="wl-card-bottom">
          <span class="wl-card-price">${formatMoney(product.price)}${product.compare_at_price && product.compare_at_price > product.price ? ` <s class="price-compare">${formatMoney(product.compare_at_price)}</s>` : ''}</span>
          <button class="wl-card-add-cart" onclick="addSingleToCart(${product.variants[0].id}, this)" aria-label="Add to cart">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M12 10v6"></path><path d="M9 13h6"></path></svg>
          </button>
        </div>
      </div>
    </div>
  `;
}

// ====== EVENT LISTENERS FOR WISHLIST PAGE ======

function attachWishlistPageEvents() {
  const selectAll = document.getElementById('wishlist-select-all');
  const checkboxes = document.querySelectorAll('.wl-card-checkbox');
  const moveBtn = document.getElementById('move-to-bag-btn');
  
  if (selectAll && checkboxes.length > 0) {
    selectAll.addEventListener('change', (e) => {
      checkboxes.forEach(cb => cb.checked = e.target.checked);
      updateMoveToBagBtn();
    });
    
    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        updateMoveToBagBtn();
        // Update select all state
        const allChecked = Array.from(checkboxes).every(c => c.checked);
        selectAll.checked = allChecked;
      });
    });
    
    if (moveBtn) {
      moveBtn.addEventListener('click', async () => {
        const selected = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value);
        if (selected.length === 0) return;
        
        moveBtn.innerHTML = 'Adding...';
        moveBtn.disabled = true;
        
        let formData = {
          'items': selected.map(id => ({ id: parseInt(id), quantity: 1 }))
        };
        
        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          });
          
          updateCartBadge();
          moveBtn.innerHTML = 'Added to Bag!';
          
          checkboxes.forEach(cb => cb.checked = false);
          if (selectAll) selectAll.checked = false;
          
          setTimeout(() => {
            moveBtn.innerHTML = 'MOVE TO BAG';
            updateMoveToBagBtn();
          }, 2000);
          
        } catch (err) {
          console.error(err);
          moveBtn.innerHTML = 'Error';
          setTimeout(() => {
            moveBtn.innerHTML = 'MOVE TO BAG';
            moveBtn.disabled = false;
          }, 2000);
        }
      });
    }
  }
  
  // Re-init the heart buttons we just rendered so they work
  initWishlistIcons();
}

function updateMoveToBagBtn() {
  const checkboxes = document.querySelectorAll('.wl-card-checkbox');
  const moveBtn = document.getElementById('move-to-bag-btn');
  if(!moveBtn) return;
  
  const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
  moveBtn.disabled = !anyChecked;
}

function addSingleToCart(variantId, btnElement) {
  if (btnElement) {
    btnElement.innerHTML = '<span style="font-size:12px; font-weight: bold;">...</span>';
  }
  let formData = {
    'items': [{ id: parseInt(variantId), quantity: 1 }]
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(res => {
    updateCartBadge();
    if (btnElement) {
      btnElement.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24"><path d="M20 6L9 17l-5-5"></path></svg>'; // Checkmark
      setTimeout(() => {
        btnElement.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="24" height="24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M12 10v6"></path><path d="M9 13h6"></path></svg>';
      }, 2000);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateCartBadge() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let cartBtn = document.getElementById('btn-cart');
      if (cartBtn) {
        let badge = cartBtn.querySelector('.cart-count');
        if (cart.item_count > 0) {
          if (badge) {
            badge.textContent = cart.item_count;
          } else {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            badge.textContent = cart.item_count;
            cartBtn.appendChild(badge);
          }
        } else {
          if (badge) badge.remove();
        }
      }
    });
}
